<template>
 <div v-if="filter.selectType == 2" class="department-bar" style="display: inline-block">
 <!-- <div v-if="filter.selectType == 2&&!portrait&&!isCordova() && departmentId && departmentId != 0"  class="department-bar" style="display: inline-block"> -->
    <span>{{ $t('Home.Header.department') }}</span>
    <span class="department-text"  @click.stop="departmentBar.selecting = !departmentBar.selecting">
        <span :title="departmentName">{{departmentName}}</span>
        <icon class="icon department-icon" :type="departmentBar.selecting ? 'md-arrow-dropup' : 'md-arrow-dropdown'"></icon>
        <div class="department-select" v-show="departmentBar.selecting" @click.stop="departmentBar.selecting = true">
            <i-button size="small" style="margin-left:100px;" @click="expandAll" type="info">查询</i-button><br>
            <Tree ref="departmentBarTree" :data="departmentBar.treeData" multiple show-checkbox check-directly check-strictly
                    @on-check-change="onDepartmentTreeCheck" @on-toggle-expand="onExpandChange"></Tree>
        </div>
    </span>
</div>              
</template>
<script>
import api from "@/api/Api";
import extend from "extend";
import { mapState, mapMutations } from "vuex";
import helper from "@/assets/helper.js";
/*
    额外需求 NEED：
    NEED-1 输入完整名字后，自动选择
    NEED-2 手动清空输入后，需要显示可选列表
    NEED-3 外部可以获取label

*/
export default {
    props:["filterPath"],
    data() {
        return {
                parent : null,
                root:[],
                curr:null,
                departmentBar: {
                    selecting: false,
                    treeData: []
                },
                portrait: this.isPortrait(),
                side_hide: this.isPortrait()
        }
    },
    watch: {
            'departmentBar.selecting'(yes) {
                yes && this.getDepartmentList();
            }
        
    },
    computed: {
            filter: {
                get() {
                    if(this.filterPath === "views/liveRoom.all.filter"){
                        return this.$store.state.views.liveRoom.all.filter;
                    }else if(this.filterPath === "views/relatedReport.all.filter"){
                        return this.$store.state.views.relatedReport.all.filter;
                    }else if(this.filterPath === "views/liveRecord.all.filter"){
                        return this.$store.state.views.liveRecord.all.filter;
                    }else if(this.filterPath === "views/category.all.filter"){
                        return this.$store.state.views.category.all.filter;
                    }else if(this.filterPath === "views/watermark.all.filter"){
                        return this.$store.state.views.watermark.all.filter;
                    }else if(this.filterPath === "views/cloudEditor.all.filter"){
                        return this.$store.state.views.cloudEditor.all.filter;
                    }else if(this.filterPath === "views/materialTemplate.all.filter"){
                        return this.$store.state.views.materialTemplate.all.filter;
                    }else if(this.filterPath === "views/realEditor.all.filter"){
                        return this.$store.state.views.realEditor.all.filter;
                    }else if(this.filterPath === "views/director.all.filter"){
                        return this.$store.state.views.director.all.filter;
                    }else if(this.filterPath === "views/liveCategory.all.filter") {
                        return this.$store.state.views.liveCategory.all.filter;
                    }
                    throw new Error("非法的 filterPath 参数");
                },
                set(v) {
                    this.$store.commit(this.filterPath, v);
                }
            },
            ...mapState({
                userName: state => state.user.name,
                departmentName: state => state.department.currentName,
                departmentId: state => state.department.currentId
            }),
    },
    methods: {
        expandAll(){
            if(this.curr==null){

                return ;
            }

            let list = this.treeToList(this.departmentBar.treeData);
            let parents = this.findParents(this.curr.id, list);
            parents.forEach(e => e.expand = true);
        },
        onExpandChange(){

        },
        async getDepartmentList() {
            try {
                let data = this.$store.state.user.departmentMenus;
                let tree = data;
                helper.travel(tree, "children", n => {
                    n.title = n.name.length>10?n.name.substring(0,8)+"...":n.name;;
                    n.checked = (n.id == this.$store.state.department.currentId);
                    // n.expand = helper.hasCheckedNode(n, this.depId)
                });
                if(tree[0]) {
                    tree[0].expand = true;
                }
                this.departmentBar.treeData =tree;
                if(this.curr==null){
                   this.curr = tree[0]
                }
            } catch (e) {
            this.$Notice.error({
                    title: e.message
                });
            }
        },
        onDepartmentTreeCheck(checked, curr) {
            // 只允许选择一个节点
            curr.checked = true;
            checked.forEach(n => n.checked = false);
            this.departmentBar.selecting = false;

            this.$store.commit("department/current", {
                id: curr.id,
                name: curr.title
            });
            this.curr = curr;

        },
        // 2.给了树中间的某个节点，如何去寻找该节点所有的父级节点呢？
        // 答案是：把树拉平。（每个节点之间的联系依靠parentKey属性）
        treeToList(data){
            const flattenData = [];
            function flattenTree(data, parentKey) {
                data.forEach(ele => {
                    flattenData.push(ele);
                    if (ele.children){
                        flattenTree(ele.children, ele.id);
                    }
                })
            }
            flattenTree(data, null);
            return flattenData;
        },
        // 3.给个节点0-0-1-0，找到ta所有的父级节点
        findParents(item, flattenTree) {
            const parentArr = []; // 存储所有的父级元素
            function find(item, flattenTree) {
                flattenTree.forEach(ele => {
                    if (ele.id === item){
                        parentArr.push(ele);
                        find(ele.pId, flattenTree);
                    }
                })
            }
            find(item, flattenTree);
            return parentArr;
        },
    },
    destroyed() {
        document.removeEventListener('click', this.docClick);  
    },
    mounted() {
            this.isPortrait((e)=>{ 
                this.$data.portrait = e.matches;
                this.$data.side_hide = e.matches;
            })
            this.docClick = ()=>{
                this.departmentBar.selecting = false;
            };
            document.addEventListener('click', this.docClick);
            let data = this.$store.state.user.departmentMenus;
            let tree = data;
            helper.travel(tree, "children", n => {    
                if(n.checked){
                        this.curr = n;
                } 
            });
    }
};
</script>


<style lang="less" scoped>
@media all and (orientation : portrait){ 

    .filter{
        padding:5px
    }
    .menuSider{
        position: absolute;
        z-index:1000;
        // overflow:hidden;
        box-shadow: rgba(0,0,0,0.3) 0 0 10px
    }
    .menuSider .ivu-layout-sider-children{
        position: absolute!important;
        right:0;
        width:150px!important;
    }
    .menuSiderMask{
        background:rgba(255,255,255,0.9);height:100%;width:100%;
        position: absolute;z-index:999;
        display:block;
    }
    /* .menuSider  */

}
.department-bar {
    position: relative;
    color: black;
    margin-right: 30px;
    // border: 4px solid green;
    .department-icon{
        transform: translate(-2px,-8px)
    };

    .department-text {
        display: inline-block;
        cursor: pointer;
        background: #fff;
        color: #164b81;
        border: 1px solid #dcdee2;
        width: 100px;
        height: 24px;
        line-height: 23px;
        vertical-align: middle;
        text-align: center;
        border-radius: 6px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        
        .icon {
            position: absolute;
            right: 5px;
            top: 17px;
        }
    }

    .department-select {
        border:1px solid #dcdee2;
        background: #fff;
        color: black;
        border-radius: 6px;
        padding: 10px;
        padding-left: 30px;
        width: 200px;
        height: 300px;
        overflow-y: scroll;
        display: inline-block;
        position: absolute;
        margin-top: 39px;
        left:0;
        z-index: 9999;
        text-align: left;
        line-height: 1.5;
    }
}

// /deep/ .ivu-tree ul li{
// // transform:translateX(100px);
//     margin-left:30px ;
    
// }
// /deep/ .ivu-tree ul {
// // transform:translateX(100px);
//     margin-left:0px ;
    
// }
</style>